// Import React and necessary CSS
import React from 'react';
import './ResponsiveImageContainer.css'; // Make sure to create this CSS file

const ResponsiveImageContainer = ({ src, children, height='50vw', width='50vw' }) => {
  return (
    <div className="responsive-image-container" style={{height: height, width: width}}>
      <img src={src} alt="Responsive content" />
      <div className="responsive-overlay">
        {children}
      </div>
    </div>
  );
};

export default ResponsiveImageContainer;
